import { AppliedDiscountCode } from 'modules/benefitCodes'
import { Cart } from 'modules/cart'
import { CustomerAddress } from 'modules/customer'
import { DeliveryTimeProps } from 'modules/delivery'

import { SaleOrder } from '../../types'
import { PaymentMethod } from '../payment/types'

export interface EditOrderBase {
  orderId: string
  orderNo: string
}

export interface EditOrderProducts extends EditOrderBase {
  products: {
    start: {
      length: number
    }
    current: {
      length: number
      productsRemoved: string[]
      productsAdded: string[]
    }
  }
}

export interface EditOrderDelivery extends EditOrderBase {
  deliveryAddress: CustomerAddress
  deliveryTime: DeliveryTimeProps
}

export type ComparisonResult<T> = {
  current: T
  start: T
}

export type ProductChanges = {
  length: number
  productsAdded: number
  productsRemoved: number
}

export type CartChanges = {
  orderNo: string
  orderId: string
  products: ComparisonResult<ProductChanges>
  deliveryTime: ComparisonResult<{
    date: string | undefined
    time: string | undefined
  }>
  deliveryAddress: ComparisonResult<CustomerAddress | null>
  paymentMethod: ComparisonResult<PaymentMethod | null>
  discountCodes: ComparisonResult<AppliedDiscountCode[]>
  payment: ComparisonResult<{
    paid?: number | null
    diff?: number | null
  }>
}

export enum EditSaleOrderCartKeys {
  EDIT_MODE_START_CART = 'edit-mode-start-cart',
  EDIT_MODE_START_ORDER = 'edit-mode-start-order',
  EDIT_MODE_START_PAYMENT_METHOD = 'edit-mode-start-payment-method',
  EDIT_MODE_OLD_CART = 'edit-mode-old-cart'
}

export type EditSaleOrderCart = Cart & { saleOrder?: SaleOrder }

export interface EditSaleOrderCartResponse {
  data: {
    data: EditSaleOrderCart
  }
}
